module.exports = __webpack_public_path__ + "media/images/menu/sculptor-9c57c8bc53254c2fffd9ee165634468d.jpg";